import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Button, Box} from 'views/components';
import {Author, EmojiBar, MarkdownEditor, MarkdownViewer} from 'views/module';
import {Translate} from 'views/module';

const Message = (props) => {
  const [newMessage, setNewMessage] = React.useState(props.message);
  const [loading, setLoading] = React.useState(false);

  const {
    fullName,
    timestampLabel,
    userRn,
    message,
    truncate,
    editMode,
    onClickSave,
    onClickCancel,
    emojis,
    onEmojiSelected,
    emojisWithRequesterData,
  } = props;

  return (
    <Stack
      sx={{
        py: {md: 2, xs: 1},
      }}
    >
      <Author
        fullName={fullName}
        timestampLabel={timestampLabel}
        nameSx={{fontWeight: 500}}
      />
      {
        editMode ? (
          <Stack spacing={2}>
            <MarkdownEditor
              value={newMessage}
              onChange={setNewMessage}
              autoFocus
            />
            <Stack direction="row" spacing={1} justifyContent="flex-end">
              <Button variant="outlined" sx={{height: '42px'}} onClick={onClickCancel}>
                <Translate expression='generic.Cancel'/>
              </Button>
              <Button
                sx={{height: '42px'}}
                disabled={loading}
                onClick={(event) => onClickSave(event, newMessage, setLoading)}
                loading={loading}
              >
                <Translate expression='generic.Save' />
              </Button>
            </Stack>
          </Stack>
        ) :
          (
            <MarkdownViewer value={message} truncate={truncate} />
          )
      }
      {
        emojis && Object.values(emojis).length > 0 && (
          <Box
            sx={{my: 1}}
          >
            <EmojiBar
              emojis={emojis || {}}
              emojisWithRequesterData={emojisWithRequesterData || {}}
              requesterRn={userRn}
              onEmojiSelected={onEmojiSelected}
            />
          </Box>
        )
      }
    </Stack>
  );
};

Message.propTypes = {
  userRn: PropTypes.string,
  fullName: PropTypes.string.isRequired,
  message: PropTypes.string,
  emojis: PropTypes.object,
  editMode: PropTypes.bool,
  onClickSave: PropTypes.func,
  onClickCancel: PropTypes.func,
  onEmojiSelected: PropTypes.func,
  emojisWithRequesterData: PropTypes.object,
  timestampLabel: PropTypes.string,
  truncate: PropTypes.bool,
};

export default React.memo(Message);
